/** @file BulkFitPrompt: lists uploaded images of the wrong size and asks Pad all / Scale all / Skip. */
import type { ReactElement } from 'react';
import { ArtModal } from './ArtModal';
import type { FitMode, MisfitImage } from './artTypes';

/** The misfits and the choice callback (`null` = leave them out). */
export type BulkFitPromptProps = { misfits: MisfitImage[]; choose: (fit: FitMode | null) => void };

const BUTTON = { padding: '3px 10px', fontSize: 12, borderRadius: 4, border: '1px solid #555', background: '#2f333b', color: '#eee', cursor: 'pointer' };
const SHOWN = 8;

/** One dialog for all of them: the same fit applies to every listed image. */
export function BulkFitPrompt({ misfits, choose }: BulkFitPromptProps): ReactElement {
  return (
    <ArtModal label="Image sizes differ">
      <strong>{misfits.length} {misfits.length === 1 ? 'image is' : 'images are'} not the size of {misfits.length === 1 ? 'its slot' : 'their slots'}</strong>
      <ul style={{ margin: 0, paddingLeft: 18, overflow: 'auto' }}>
        {misfits.slice(0, SHOWN).map((m) => <li key={m.slot}>{m.name}: {m.size[0]}x{m.size[1]}, slot {m.slotSize[0]}x{m.slotSize[1]}</li>)}
        {misfits.length > SHOWN ? <li>and {misfits.length - SHOWN} more</li> : null}
      </ul>
      <div style={{ display: 'flex', gap: 6, justifyContent: 'flex-end' }}>
        <button type="button" style={BUTTON} onClick={() => { choose('pad'); }}>Pad all</button>
        <button type="button" style={BUTTON} onClick={() => { choose('scale'); }}>Scale all</button>
        <button type="button" style={BUTTON} onClick={() => { choose(null); }}>Skip them</button>
      </div>
    </ArtModal>
  );
}
